import { Action } from '@ngrx/store';
import { Invoice } from './invoice';

export const GET_INVOICES = 'GET_INVOICES';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE';

export class GetInvoicesAction implements Action {
  readonly type = GET_INVOICES;

  constructor() {}
}

export class GetInvoicesSuccessAction implements Action {
  readonly type = GET_INVOICES_SUCCESS;

  constructor(public payload: Invoice[]) {}
}

export class GetInvoicesFailureAction implements Action {
  readonly type = GET_INVOICES_FAILURE;

  constructor(public payload: any) {}
}

export type InvoicesAction = GetInvoicesAction | GetInvoicesSuccessAction | GetInvoicesFailureAction;
